import React, { Component } from 'react';
import '../../../src/styles/ShoppingCart.css';
import '../../../src/styles/open-iconic.css';
import '../../../src/styles/open-iconic-bootstrap.css';
import { appService } from '../../_services';
import { Redirect, Route } from 'react-router-dom'
import DocumentMeta from 'react-document-meta';

let params = '', parameters = '', linkdata = '';
export class Email extends Component {
    displayName = Email.name
    constructor(props) {
        super(props);
        this.state = {
            emailReciepient: '',
            Subject:'',
            Message: '',
            link: ''
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

    }
    componentWillMount() {
        let linkData = '';
        if (localStorage && localStorage.getItem('link')) {
            linkData = JSON.parse(localStorage.getItem('link'));
        }
        this.setState({
            link: linkData,
            Subject: 'Email Link' })
    }
    handleChange(event) {
        
        if (event.target.value == 'link') {
            this.setState({
                link: JSON.parse(localStorage.getItem('link')),
                Subject: 'Email Link'
            });
        }
        if (event.target.value == 'pdf') {
            this.setState({
                link: '', Subject: 'Email PDF'
            });
        }

    }
    handleValidation() {
        var self = this;
        let fields = self.state.fields;
        let errors = {};
        let formIsValid = true;

        var emaiTo = this.refs["emaiTo"].value;
        var Body = this.refs["Body"].value;
        if (emaiTo == "" || emaiTo == 'undefined') {
            formIsValid = false;
            this.state.emailReciepient = "Please enter a valid email address";
        }
        if (emaiTo != "") {
            let lastAtPos = emaiTo.lastIndexOf('@');
            let lastDotPos = emaiTo.lastIndexOf('.');

            if (!(lastAtPos < lastDotPos && lastAtPos > 0 && emaiTo.indexOf('@@') == -1 && lastDotPos > 2 && (emaiTo.length - lastDotPos) > 2)) {
                formIsValid = false;
                this.state.emailReciepient = "Email is not valid";
            }
        }

        if (Body == "" || Body == 'undefined') {
            formIsValid = false;
            this.state.Message = "Please enter email content";
        }
        self.setState({ errors: errors });
        if (!formIsValid) {
            window.scrollTo({
                top: 200,
                behavior: 'smooth',
            });
            return false;
        }

        return true;
    }
    handleSubmit(event) {
        event.preventDefault();
        var self = this;
        if (self.handleValidation()) {

            var emaiTo = this.refs["emaiTo"].value;
            var Body = this.refs["Body"].value;
            var Subject = this.state.Subject;
            var Link = this.state.link;

            parameters = { To: emaiTo, Body: Body, Subject: Subject , Link: Link}

            appService.getByIssueId('/Email/SendEmail', parameters)
                .then(function (data) {

                    if (data == "Success") { 
                        alert(5);
                        window.location = "http://localhost:62283/ThankyouSubscription";
                    }
                });
        }
        else {
            return false;
        }
    }
    render() {
        const meta = {
            title: "Kluwer Law Online - Email"
        }
        return (
            <DocumentMeta {...meta}>
            <div>
                <div className="col-12">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="row">
                                <div className="col-lg-9" >
                                    <h1 className="TitlePadding Title" style={{ marginTop: '40px', marginBottom: '20px', marginLeft: '25px', fontFamily: 'Franziska Helvetica Neue Helvetica sans-serif !important', fontStyle: 'italic', fontWeight: 'normal' }}>Email documents</h1>
                                </div>
                            </div>
                            <br></br>
                            <div className="row">

                                <div className="col-lg-11 TitlePadding" style={{ marginLeft: '25px' }}>
                                    <label for="Email"><b>Email recipients</b></label>
                                    <input type="search" className="form-control" id="emailAddress" ref="emaiTo" placeholder="Enter email addresses" />
                                    <p style={{ marginLeft: '8px' }} for="emailAddress">Separate recipients with a semi-colon</p>
                                    <span className="error">{this.state.emailReciepient}</span>

                                </div>


                            </div>
                            <br></br>
                            <div className="row">

                                <div className="col-lg-11 TitlePadding" style={{ marginLeft: '25px' }}>
                                    <label for="Email"><b>Message to recipients (optional)</b></label>
                                    <textarea type="textArea" rows="4" cols="50" className="form-control form-control-sm rounded-0" id="Message" ref="Body" placeholder="Enter message" />
                                    <span className="error">{this.state.Message}</span>
                                </div>
                            </div>
                            <br></br>
                            <div className="row">

                                <div className="col-lg-11 TitlePadding" style={{ marginLeft: '25px' }}>
                                    <label for="Email"><b>Email content as</b></label>
                                    <div className="col row">
                                        <div className="custom-control custom-radio col-2">
                                            <label className="radiocontainer"><input type="radio" name="radio" value="link" onChange={this.handleChange} defaultChecked="true"/>
                                                <span className="checkRadiomark"></span></label>
                                            <span style={{paddingLeft: '0% !important'}}>Links</span>
                                        </div>
                                        <div className="custom-control custom-radio col-6">
                                            <label className="radiocontainer"><input type="radio" name="radio" value="pdf" onChange={this.handleChange} />
                                                <span className="checkRadiomark"></span></label>
                                            <span  style={{ paddingLeft: '0% !important' }}>PDF attachment (20 documents allowed)</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br></br>
                    <div className="row" style={{ float: 'right', marginRight: '89px' }}>
                        <button type="button" className="btn btn-info grey rounded-0" style={{ marginRight: '5px' }}>Cancel</button>
                        <br></br>
                        <button type="button" className="btn btn-info next rounded-0" onClick={this.handleSubmit}>Send</button>
                    </div>
                    <div className="White">
                    </div>
                    <div className="White">
                    </div>
                </div>
            </div>
</DocumentMeta>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Email/Email.jsx